module.exports = __webpack_public_path__ + "static/kaen-1677b3ad20726cac4c3893bc80daba97.jpg";